import React from 'react'
import ComputerIcon from '@mui/icons-material/Computer';
import MoodIcon from '@mui/icons-material/Mood';
import HomeIcon from '@mui/icons-material/Home';
export const SidebarData = [
    {
        title: "Home",
        icon: <HomeIcon/>,
        link: "/"
    },
    {
        title: "About",
        icon: <MoodIcon/>,
        link: "/about"
    },
    {
        title: "Project",
        icon: <ComputerIcon/>,
        link: "/project"  
    }
]
  